'use strict';

/**
 * CUIT/CUIL argentino: 11 dígitos, o último é o dígito verificador (Módulo 11
 * com pesos 5,4,3,2,7,6,5,4,3,2 nos 10 primeiros). Resto 11 vira 0; resto 10
 * não existe em número emitido.
 *
 * Mesma regra no front (aba Domicílio fiscal) e no backend (salvar a ficha).
 */

const WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

/**
 * @param {*} value - CUIT/CUIL com ou sem separadores ("20-12345678-6" ou "20123456786")
 * @returns {string} só os dígitos
 */
function plainCuit(value) {
  return String(value ?? '').replace(/[\s.\-/]/g, '');
}

/**
 * @param {*} value - CUIT/CUIL com ou sem separadores
 * @returns {boolean} true se válido
 */
function validateCUIT(value) {
  const plain = plainCuit(value);

  if (!/^\d{11}$/.test(plain)) return false;

  const digits = plain.split('').map(Number);
  const sum = WEIGHTS.reduce((acc, weight, idx) => acc + weight * digits[idx], 0);
  const rest = 11 - (sum % 11);

  if (rest === 10) return false;

  return (rest === 11 ? 0 : rest) === digits[10];
}

export { validateCUIT, plainCuit };

export default { validateCUIT, plainCuit };
